module.exports = __webpack_public_path__ + "static/media/welcome.e1c737cd.png";